import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";

const styles = {
  page: { display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center" },
  card: { background: "#fff", padding: 32, borderRadius: 12, width: 360, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" },
  input: { width: "100%", padding: 10, marginBottom: 12, border: "1px solid #ccc", borderRadius: 6 },
  button: { width: "100%", padding: 11, background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, fontWeight: 600, cursor: "pointer" },
  error: { color: "#dc2626", marginBottom: 12, fontSize: 14 },
  success: { color: "#16a34a", marginBottom: 12, fontSize: 14 },
};

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords don't match.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    setBusy(true);
    try {
      const res = await api.post("/api/auth/reset-password", { token, new_password: password });
      setSuccess(res.data.message);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <h2 style={{ marginTop: 0 }}>Invalid link</h2>
          <p>This password reset link is missing its token. Please request a new one from the login page.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={{ marginTop: 0, textAlign: "center" }}>Set a new password</h2>
        {error && <div style={styles.error}>{error}</div>}
        {success ? (
          <div style={styles.success}>{success} Redirecting to login...</div>
        ) : (
          <form onSubmit={submit}>
            <input
              style={styles.input}
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <input
              style={styles.input}
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button style={styles.button} type="submit" disabled={busy}>
              {busy ? "Resetting..." : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
